import { Polygon } from "@react-google-maps/api"
import { AllDcLocationsQuery } from "generated/graphql"
import React from "react"
import { gisToJson } from "utils/map.utils"
import PinMarker from "../Molecules/PinMarker"

interface DCLocationPolygonProps {
  /**
   * The distribution center for which to lay out the polygon
   * Requires basic keys like, geometry, properties and id
   */
  distributionCenter?: AllDcLocationsQuery["allDistributionCentreLocations"][0]
}
const DCLocationPolygon = ({
  distributionCenter: dc,
}: DCLocationPolygonProps) => {
  const address = dc?.properties?.address
  const color = dc?.properties?.colorCode
  const areas = dc?.geometry?.coordinates
  return (
    <>
      <PinMarker
        icon={{
          url: "https://cdn.vesatogo.com/images/pin-marker.png",
          scaledSize: new window.google.maps.Size(39, 39),
        }}
        title={dc?.properties?.name}
        latitude={address?.latitude}
        longitude={address?.longitude}
      />
      {areas?.map((a: any, areaId: any) => {
        const coordinates = gisToJson(a[0])

        return (
          <Polygon
            options={{
              fillColor: color,
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillOpacity: 0.1,
            }}
            path={coordinates}
            key={areaId}
          />
        )
      })}
    </>
  )
}

export default DCLocationPolygon
